import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    buildingComplexId: String,
    filterActive: Boolean
  }
  static params = ["buildingComplexId"]
  static targets = ["filterContainer", "modelSearch", "filterToggleButton"]
  static outlets = ["resident-report-breadcrumbs"]

  connect() {
    this.notifyFilterState()
  }

  handleFormSubmit(event) {
    // Check if the form submission was for the search form
    if (event.target.id === 'model_searchform') {
      // Check if there are any filled form fields to determine if filter will be active
      const formData = new FormData(event.target)
      let hasActiveFilters = false
      const entries = []

      // Check all form fields except ignored ones
      const ignoredFields = ['clear', 'building_complex_id', 'authenticity_token', 'commit']
      for (const [key, value] of formData.entries()) {
        entries.push({ key, value })
      }

      // Special handling: if the clear flag is set explicitly, treat as no active filters
      if (formData.get('clear') === '1') {
        hasActiveFilters = false
      } else {
        for (const entry of entries) {
          const { key, value } = entry
          if (ignoredFields.includes(key)) {
            continue
          }

          const normalizedValue = typeof value === 'string' ? value.trim() : value
          if (normalizedValue === '' || normalizedValue === '0' || normalizedValue === null) {
            continue
          }

          hasActiveFilters = true
          break
        }
      }

      // Update icon based on whether filters will be active, then collapse panel
      this.filterActiveValue = hasActiveFilters
      this.closeFilter()
    }
  }

  closeFilter() {
    if (this.hasFilterContainerTarget) {
      this.filterContainerTarget.classList.remove('show')
      this.notifyFilterState()
    }
  }

  filterActiveValueChanged() {
    this.notifyFilterState()
  }

  clearForm() {
    document.getElementById("model_searchform").querySelector("#clear").value = 1;
    document.getElementById("model_searchform").setAttribute("data-turbo", "false");
    document.getElementById("model_searchform").requestSubmit();
  }

  toggleFilter() {
    if (this.hasFilterContainerTarget) {
      // Toggle the show class for smooth animation
      this.filterContainerTarget.classList.toggle('show')

      // Notify breadcrumbs about current filter state
      this.notifyFilterState()
    }
  }

  updateFilterButtonState(isVisible) {
    // Use outlet to update the filter button state in breadcrumbs controller
    if (this.hasResidentReportBreadcrumbsOutlet) {
      this.residentReportBreadcrumbsOutlet.updateFilterButtonState(isVisible)
    }
  }

  updateFilterIcon(isActive) {
    // Use outlet to update the filter icon in breadcrumbs controller
    if (this.hasResidentReportBreadcrumbsOutlet) {
      this.residentReportBreadcrumbsOutlet.updateFilterIcon(isActive)
    }
  }

  updateBreadcrumbs(event) {
    // Update breadcrumbs when building complex changes
    const buildingComplexId = event.currentTarget.dataset.buildingComplexId
    if (this.hasResidentReportBreadcrumbsOutlet) {
      this.residentReportBreadcrumbsOutlet.buildingComplexIdValue = buildingComplexId
    }
  }

  notifyFilterState() {
    if (!this.hasResidentReportBreadcrumbsOutlet) return

    const isVisible = this.hasFilterContainerTarget ? this.filterContainerTarget.classList.contains('show') : false
    const isActive = !!this.filterActiveValue

    this.updateFilterButtonState(isVisible)
    this.updateFilterIcon(isActive)
  }

  residentReportBreadcrumbsOutletConnected() {
    this.notifyFilterState()
  }
}
